var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 680.62,
    height: 800.057,
    viewBox: "0 0 680.62 800.057",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(-620 -140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1240-704",
    "data-name": "Path 1240",
    d: "M893.89,382.941,918.853,402.1l6.644-34.172-18.723-8.053C906.015,368.829,901.539,376.454,893.89,382.941Z",
    transform: "matrix(0.951, -0.309, 0.309, 0.951, -15.819, 327.307)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256-705",
    "data-name": "Path 2256",
    d: "M961.785,775.308a1.572,1.572,0,0,1-.371,1.033,1.189,1.189,0,0,1-.9.426H282.435a1.473,1.473,0,0,1,0-2.919h678.08a1.189,1.189,0,0,1,.9.426,1.573,1.573,0,0,1,.371,1.033Z",
    transform: "translate(338.835 163.29)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257-706",
    "data-name": "Path 2257",
    d: "M833.335,159.91a30.4,30.4,0,0,0-6.892-14.47,58.252,58.252,0,0,0-82.211-5.31l-.49.441a59.426,59.426,0,0,0-95.6,18.395,55.363,55.363,0,0,0,2.489,50.266,58.162,58.162,0,0,0,6.855,9.59c2.686,3.066,75.185,83.72,75.908,84.529a.916.916,0,0,0,.7.319c.025,0,.061-.012.1-.012a.327.327,0,0,0,.147-.037.938.938,0,0,0,.576-.417l.38-.625.454-.773,6.708-11.208c18.6-31.087,43.681-60.42,74.547-87.178a47.865,47.865,0,0,0,5.506-5.641,49.627,49.627,0,0,0,11.4-27.911,39.154,39.154,0,0,0-.576-9.958Z",
    transform: "translate(369.781 16.186)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258-707",
    "data-name": "Path 2258",
    d: "M535.576,683.029l13.654-44.467a150.084,150.084,0,0,0-59.992-40.193c22.442,37.18.7,85.682,9.758,128.154a90.274,90.274,0,0,0,48.353,61.52l20.72,25.672a151.272,151.272,0,0,0,11.118-126.172,146.118,146.118,0,0,0-16.919-32.519C549.954,669.5,535.576,683.029,535.576,683.029Z",
    transform: "translate(334.922 123.578)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259-708",
    "data-name": "Path 2259",
    d: "M480.424,682.391,472.814,636.5a150.082,150.082,0,0,0-71.621-9.219c36.668,23.269,38.835,76.378,65.888,110.351a90.275,90.275,0,0,0,70.715,33.5L567.79,784.87a151.272,151.272,0,0,0-46.319-117.888,146.124,146.124,0,0,0-29.646-21.561C487.26,663.869,480.424,682.391,480.424,682.391Z",
    transform: "translate(314.998 129.897)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260-709",
    "data-name": "Path 2260",
    d: "M307.566,305.666l-3.77,8.768,6.161,31.143,62.854-8.74-.5-37.974-1.262-8.318Z",
    transform: "translate(637.75 205.698)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261-710",
    "data-name": "Path 2261",
    d: "M280.389,641.875h19.177l7.406-53.486H280.389Z",
    transform: "translate(629.914 273.101)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263-711",
    "data-name": "Path 2263",
    d: "M345.546,646.824h16.945l9.968-78.745-31.84-1.557Z",
    transform: "translate(644.86 268.152)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264-712",
    "data-name": "Path 2264",
    d: "M677.375,770.995l-28.413-14.547v-9.5l-7.575.153-15.451.932-4.033.236-2.8,33.53h9.943l1.766-9.387,4.548,9.387h38.645a5.928,5.928,0,0,0,3.366-10.806Z",
    transform: "translate(365.538 157.202)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265-713",
    "data-name": "Path 2265",
    d: "M557.449,780.5h.054l2.667-86.968a22.741,22.741,0,0,1,.3-21.49l.382-.691-.99-4.589a29.231,29.231,0,0,1,1.67-17.592l2.488-81.125c-8.888-57.6,33.471-95.172,33.471-95.172L593.6,442.686l68.514,1.557-1.165,28.635,13.623,46.806c7.169,69.85,7.6,138.28.262,205.076a1.278,1.278,0,0,0,.084.564,17.053,17.053,0,0,1-1.377,13.761,5.2,5.2,0,0,0-.62,1.707c-1.511,11.71-1.708-3.1-3.71,8.5l.39.2c1.4.484,2,2.428,1.344,4.341s-2.333,3.072-3.736,2.587l-36.626.391c-1.4-.484-2-2.428-1.344-4.341s2.333-3.072,3.736-2.587l2.279,1.152-3.812-12.472-1.336-1.248a5.809,5.809,0,0,1,.738-9.077h0l1.108-36.21.539-15.329-1.111-17.39-5.137-78.22-19.443,96.189-19.86,104.191a3.64,3.64,0,0,1,1.139,3.376,3.774,3.774,0,0,1-3.76,2.986H557.352a3.672,3.672,0,0,1-3.536-4.649A3.717,3.717,0,0,1,557.449,780.5Z",
    transform: "translate(349.507 88.347)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266-714",
    "data-name": "Path 2266",
    d: "M576.305,312.423A33.921,33.921,0,1,0,634.65,288.9l-.163-.163c-.271-.285-.543-.57-.828-.841a.014.014,0,0,1-.01,0,.013.013,0,0,1,0-.01,7.114,7.114,0,0,1-1.072-.963c-4.579-6.4-9.771-11.764-22.347-8.412C592.121,283.328,576.305,293.685,576.305,312.423Z",
    transform: "translate(354.626 50.958)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267-715",
    "data-name": "Path 2267",
    d: "M749.464,296.354a12.425,12.425,0,0,1-14.077,12.84l-87.481,71.8L634.544,357.5l90.193-63.188a12.493,12.493,0,0,1,24.727,2.039Z",
    transform: "translate(367.806 52.506)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268-716",
    "data-name": "Path 2268",
    d: "M617.29,394.359s2.85,5.913,13.934-2.486c8.874-6.724,51.236-35.737,60.646-48a9.761,9.761,0,0,0,11.637-2.791L680.362,318.8c-7.263.491-7.337,5.35-6.715,8.141l-18.6,7.391L606.6,362.163l8.555,27.958Z",
    transform: "translate(361.481 60.311)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_417",
    "data-name": "Ellipse 417",
    cx: 28.445,
    cy: 28.445,
    r: 28.445,
    transform: "translate(944.766 342.786)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269-717",
    "data-name": "Path 2269",
    d: "M658.936,446.637l.292-15.868c1.154-1.585,10.833-15.423,8.664-29.246-1.015-6.508-4.548-11.974-10.472-16.23l-3.824-8.9-5.66-13.156-16.563-9.86-2.295-4.673-1.891-3.88-22.849-2.281-5.632,7.579-.111.014a36.971,36.971,0,0,0-14.255,6.675,37.618,37.618,0,0,0-14.88,30.011l.139,18.441.028,2.642.014,2.559,14.255,38.369.542,1.488,5.591,15.034-.96,1.585a8.418,8.418,0,0,0,1.85,10.806l.668,9.4,1.21-.334,6.884-1.919,52.068-14.533a9.456,9.456,0,0,0,4.937-3.324,2.017,2.017,0,0,0,.125-.181,5.24,5.24,0,0,0,.542-.821c1.182-2.99,1.307-3.8,1.321-4.631a11.419,11.419,0,0,0,.556-14.38Z",
    transform: "translate(353.076 65.684)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270-718",
    "data-name": "Path 2270",
    d: "M586.668,326.375c.258-.041.516-.1.773-.136,4.437-.787,8.874-1.56,13.3-2.361l.407-10.027,5.359,8.982c12.225,4.057,23.664,1.764,34.423-3.3a97.191,97.191,0,0,0,10.312-5.685c1.093-16.958-5.763-27.815-18.521-26.676-.466.042-.8-.434-1.208-.638a.013.013,0,0,1-.01,0,.013.013,0,0,1,0-.01c-.692-.326-1.4-.638-2.1-.923a31.332,31.332,0,0,0-32.89,6.377C587.821,300.269,583.913,313.96,586.668,326.375Z",
    transform: "translate(356.773 52.312)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271-719",
    "data-name": "Path 2271",
    d: "M621.533,283.416a5.272,5.272,0,0,1-4.353,3.755c-3.825,4.728-8.205,9.735-14.2,10.681a6.829,6.829,0,0,1-4.993-.862,2.78,2.78,0,0,1-.5-.4c-1.418-1.349-1.53-4.061.153-5.076-7.538,2.99-11.946,11.126-13.059,19.15s.431,16.132,1.446,24.17,1.46,16.48-1.7,23.948c-3.727,8.8-12.294,15.131-21.639,17.147-.834.181-1.669.334-2.517.431a25.682,25.682,0,0,0-4.144-10.653,22.979,22.979,0,0,1-.987,11.014,43.886,43.886,0,0,1-20.123-5.2c-8.469-4.464-15.52-11.279-21.292-18.914,9.944,7.051,23.684,9.693,34.5,4.116,9.679-5.007,15.4-15.52,17.9-26.117s-8.018-23.612-6.878-34.445,14.221-20.029,21.369-28.248c4.562-5.243,11.292-9.123,18.232-8.469a16.383,16.383,0,0,1,14.352,20.235c1.975-2.8,7.079-2.183,8.344,1A4.122,4.122,0,0,1,621.533,283.416Z",
    transform: "translate(340.442 46.862)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272-720",
    "data-name": "Path 2272",
    d: "M587.138,325.884s8.426-31.452,44.546-38.711c.041-.013.176-.068.353-.149.108-.068.244-.136.38-.2-.407-.231-.8-.434-1.208-.638a.013.013,0,0,1-.01,0,.013.013,0,0,1,0-.01c-.353-.326-.706-.651-1.072-.963l-1.031.041S592.85,279.507,587.138,325.884Z",
    transform: "translate(357.077 52.667)",
    fill: "#fd6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273-721",
    "data-name": "Path 2273",
    d: "M666.425,441.13a4.8,4.8,0,0,0-3.977-3.012,11.421,11.421,0,0,0-5.16.747,39.683,39.683,0,0,0-16.779,10.909l.078,3.184a15.241,15.241,0,0,0,.25,19.117,9.4,9.4,0,0,0,4.879,3.159,5.489,5.489,0,0,0,5.378-1.622c1.923-2.341.994-5.869-.42-8.549a31.146,31.146,0,0,0-10.494-11.506,50.515,50.515,0,0,0,21.219-5.274,11.966,11.966,0,0,0,3.882-2.724,4.81,4.81,0,0,0,1.145-4.428Z",
    transform: "translate(368.438 87.303)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274-722",
    "data-name": "Path 2274",
    d: "M772.394,597.5l-13.765.545a44.446,44.446,0,0,0-5.349,20.705c8.189-9.917,23.875-8.6,34.855-15.293a26.735,26.735,0,0,0,12.45-19.544l5.142-8.307a44.8,44.8,0,0,0-36.348,9.265,43.267,43.267,0,0,0-7.428,7.917C767.2,594.807,772.394,597.5,772.394,597.5Z",
    transform: "translate(394.676 118.258)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275-723",
    "data-name": "Path 2275",
    d: "M716.394,719.5l-13.765.545a44.446,44.446,0,0,0-5.349,20.705c8.189-9.917,23.875-8.6,34.855-15.293a26.735,26.735,0,0,0,12.45-19.544l5.142-8.307a44.8,44.8,0,0,0-36.348,9.265,43.271,43.271,0,0,0-7.428,7.917C711.2,716.807,716.394,719.5,716.394,719.5Z",
    transform: "translate(382.003 145.867)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276-724",
    "data-name": "Path 2276",
    d: "M453.455,544.85l-11.667-7.324a44.446,44.446,0,0,0-16.108,14.066c12.359-3.559,24.557,6.39,37.4,7.064a26.735,26.735,0,0,0,21.312-9.1l8.935-3.951A44.8,44.8,0,0,0,458.1,532.725a43.269,43.269,0,0,0-10.6,2.338C450.691,539.7,453.455,544.85,453.455,544.85Z",
    transform: "translate(320.539 108.689)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277-725",
    "data-name": "Path 2277",
    d: "M734.623,285.453c-.275-1.843,1.725-3.157,2.473-4.864a7.776,7.776,0,0,0,0-4.681c-.432-2.069-.929-4.264-2.427-5.755a9.86,9.86,0,0,0-5.408-2.267,47.391,47.391,0,0,0-14.646-.259l3.691.225a19.439,19.439,0,0,0-6.885.8,6.957,6.957,0,0,0-4.619,4.811c-.457,2.278,1.1,4.947,3.417,5.142a4.465,4.465,0,1,0-1.831,8.741c-.532,1.44-2.117,2.129-3.474,2.847s-2.784,1.95-2.555,3.468c.3,2.007,2.985,2.419,5.013,2.331l22.077-.963a11.809,11.809,0,0,0,5.507-1.143c1.636-.955,2.778-3.046,2.022-4.784C736.392,287.758,734.838,286.9,734.623,285.453Z",
    transform: "translate(383.146 48.629)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278-726",
    "data-name": "Path 2278",
    d: "M524.539,442.664c-3.034,13.33-4.476,28.441,3.616,40.37A27.715,27.715,0,0,0,542.5,493.9a40.706,40.706,0,0,0,18.28,1.123c13.8-1.912,26.07-9.1,39.644-11.893,5.99-1.232,12.348-1.639,18.115.732,4.321,1.776,8.872,5.347,8.893,10.442.021,5.231-4.522,8.7-9.041,10.312-6.029,2.146-12.3,1.315-18.549,1.045-6.735-.291-13.6.318-19.2,4.443a33.391,33.391,0,0,0-10.671,14.467c-2.812,6.826-3.954,14.164-5.752,21.286a94.519,94.519,0,0,1-6.784,18.549,96.084,96.084,0,0,1-23.476,30.43c-4.831,4.157-10.7,8.393-17.3,8.774-5.089.294-11.274-1.844-13.236-7a10.049,10.049,0,0,1,4.7-11.931c4.361-2.2,9.11.939,10.519,5.247a6.717,6.717,0,0,1-.7,6.057c-1.322,1.972,1.863,3.815,3.177,1.857,3.05-4.547,1.456-10.663-2.279-14.306a10.714,10.714,0,0,0-14.1-1.051,13.932,13.932,0,0,0-5.093,14.4c1.569,5.661,7.132,9.262,12.687,10.154,6.86,1.1,13.462-1.594,19-5.49a85.17,85.17,0,0,0,15.046-13.9,99.871,99.871,0,0,0,19.923-35.623c4.049-12.976,4.344-30.117,16.376-38.88,6.191-4.509,13.778-4.009,21.037-3.6,6.408.365,12.659.3,18.538-2.6,4.854-2.4,8.771-6.817,8.852-12.45.082-5.687-3.956-10.259-8.713-12.85-12.567-6.844-27.658-1.324-40,3.248-12.415,4.6-26.591,10-39.785,5.156a24.679,24.679,0,0,1-13.634-13.027c-3.2-6.776-3.65-14.464-2.912-21.817a94.954,94.954,0,0,1,2.023-11.565c.525-2.305-3.021-3.289-3.547-.978Z",
    transform: "translate(337.188 88.043)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279-727",
    "data-name": "Path 2279",
    d: "M572.3,527.4a12.425,12.425,0,0,1,3.83-18.664l-18.7-55.361L572.7,394.7l24.622,11.131L582.13,450.087,593.5,514.5a12.493,12.493,0,0,1-21.2,12.9Z",
    transform: "translate(350.354 77.488)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280-728",
    "data-name": "Path 2280",
    d: "M595.891,355.343s-5.783-3.105-9.8,10.208c-3.22,10.658-25.132,68.526-25.527,83.979a9.761,9.761,0,0,0-7.768,9.1l31.825,4.4c5.585-4.669,2.786-8.643.641-10.534l10.84-18.361,22.656-49.567-18.641-27.062Z",
    transform: "translate(349.305 68.51)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281-729",
    "data-name": "Path 2281",
    d: "M554.461,420.429a123.667,123.667,0,0,1-16.261,34.14q-2.649,3.863-5.567,7.53a39.842,39.842,0,0,0-5.457-7.628c-7.419-8.155-17.364-13.489-27.015-18.836s-19.449-11.086-26.267-19.756a34.827,34.827,0,0,1-6.426-13.232c-1.545-6.536-.957-13.354,2.857-18.811,5.543-7.934,16.592-10.73,25.985-8.437s17.279,8.829,23.386,16.334c-2-9.222,7.726-18.125,17.131-17.315s16.948,9.038,19.449,18.137S557.159,411.379,554.461,420.429Z",
    transform: "translate(329.816 72.886)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282-730",
    "data-name": "Path 2282",
    d: "M692.225,136.81a37.276,37.276,0,0,0-24.781,15.775,36.035,36.035,0,0,0-4.8,29.651,36.756,36.756,0,0,0,8.574,15.515c1.616,1.737,4.214-.869,2.6-2.6a33.728,33.728,0,0,1-8.609-26.305,32.355,32.355,0,0,1,13.769-22.8,33.474,33.474,0,0,1,14.223-5.689c2.333-.351,1.342-3.9-.978-3.547Z",
    transform: "translate(373.871 19.121)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(1097.15 213.877)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2283-731",
    "data-name": "Path 2283",
    d: "M806.988,184.145a47.871,47.871,0,0,1-5.506,5.641c-30.866,26.758-55.944,56.091-74.547,87.178l-6.708,11.208-.454.773a18.447,18.447,0,0,1-4.084-4.255c-4.292-6.242-4.317-14.446-3.262-21.951a91.523,91.523,0,0,1,94.56-78.594Z",
    transform: "translate(-711.851 -184.059)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(797.283 475.534)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2284-732",
    "data-name": "Path 2284",
    d: "M538.054,449.35q-2.649,3.863-5.567,7.53a39.842,39.842,0,0,0-5.457-7.628c-7.419-8.155-17.364-13.489-27.015-18.836s-19.449-11.086-26.267-19.756a34.827,34.827,0,0,1-6.426-13.232,92.912,92.912,0,0,1,56.287,29.86A90.39,90.39,0,0,1,538.054,449.35Z",
    transform: "translate(-467.321 -397.429)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    cx: 4.905,
    cy: 4.905,
    r: 4.905,
    transform: "translate(1098.255 308.684)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285-733",
    "data-name": "Path 2285",
    d: "M677.375,770.995l-28.413-14.547v-9.5l-7.575.153-15.451.932-4.033.236-2.8,33.53h9.943l1.766-9.387,4.548,9.387h38.645a5.928,5.928,0,0,0,3.366-10.806Z",
    transform: "translate(286.485 157.202)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPlans);
export default __webpack_public_path__ + "static/media/show-plans.02597cafe701bf2a206b9ae8921935af.svg";
export { ForwardRef as ReactComponent };